
// eslint-disable-next-line
import MyJquery from '../../MyJquery';
import React from "react";
import 'react-trumbowyg/dist/trumbowyg.min.css';
import Trumbowyg from 'react-trumbowyg';
import { BrowserView, MobileView } from 'react-device-detect';




class Editor extends React.Component {

    
    constructor(props){
        super();

        

        this.state ={
            body:""
        };


    }

    componentDidMount =  () => {
        let $=require('jquery');
        var that = this;
        $('#editor').trumbowyg({
          fullscreenable: false
        })
        .on('tbwchange', function (){

            that.props.onChange($('#editor').trumbowyg('html'));
        });

        $('#editor').trumbowyg('html', this.state.body);
      }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.body === ""){
          let $=require('jquery');
          $('#editor').trumbowyg('empty');
        }
      }

    /**
     * RENDERING
     * @returns dom
     */
    render() { return(

        <div>
        <BrowserView>
            <Trumbowyg 
              id='editor' 
              placeholder={this.props.placeholder}
              buttons={[
                ['undo', 'redo'], // Only supported in Blink browsers
                ['formatting'],
                ['strong', 'em', 'del'],
                ['superscript', 'subscript'],
                ['link'],
                ['insertImage'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                ['unorderedList', 'orderedList'],
                ['horizontalRule'],
                ['removeformat'],
                ['fullscreen']
            ]}/>
        </BrowserView>

        <MobileView>
          <Trumbowyg 
              id='editor' 
              placeholder={this.props.placeholder}
              buttons={[
                ['strong', 'em', 'del', 'unorderedList', 'orderedList','link', 'fullscreen'  ],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
            ]}/>
        </MobileView>
        </div>
    )}
}
//<Trumbowyg id='editor' placeholder={this.props.placeholder}/>
export default Editor;